import { render, staticRenderFns } from "./RoleAccess.vue?vue&type=template&id=52cd41a5&scoped=true"
import script from "./RoleAccess.vue?vue&type=script&lang=js"
export * from "./RoleAccess.vue?vue&type=script&lang=js"
import style0 from "./RoleAccess.vue?vue&type=style&index=0&id=52cd41a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd41a5",
  null
  
)

export default component.exports